import { ErrorHandler, Injectable, NgZone, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoggingMessageService } from './services/logging-message.service';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';

@Injectable()
/**
 * Default error handling including logging and navigation.
 * Use a try/catch block whenever you don't want errors propagating up to here.
 */
export class UIErrorHandler extends ErrorHandler {

    constructor(public zone: NgZone, private injector: Injector,
                private logger: LoggingMessageService,
                private subscriptionService: SubscriptionChangeService) {
        super();
    }

    /** Default logging and navigation */
    handleError(error) {
        super.handleError(error);
        this.handleLogging(error);
        this.handleNavigation(error);
    }

    private handleLogging(error) {
        if (!navigator.onLine) {
            this.logger.error('error-handler', 'handleLogging', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  `Offline Error - ${error.message}`, error.stack);
        } else if (error instanceof HttpErrorResponse) {
            // Logged by Interceptor
            // this.errorService.errorMessage = `Service Responded with an error - ${error.statusText}`;
        } else if (error instanceof TypeError) {
            this.logger.error('error-handler', 'handleLogging',   this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  `Type Error - ${error.message}`, error.stack);
        } else if (error instanceof Error) {
            this.logger.error('error-handler', 'handleLogging',   this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, `${error.message}`, `${error.stack}`);
        } else {
            this.logger.error('error-handler', 'handleLogging',   this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, `Unexpected - ${error.message}`, `${error.stack}`);
        }
    }

    private handleNavigation(error) {
        this.zone.run(() => {
            const router = this.injector.get(Router);
            if ((error instanceof HttpErrorResponse) && (error.status === 401)) {
                router.navigate(['/login']);
            } else {
                router.navigate(['']);
            }
        });
    }
}
